import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import UnallocatedExpensesIndexTable from './UnallocatedExpensesIndexTable';

export default function UnallocatedExpensesIndex(props) {
    return <UnallocatedExpensesIndexTable fetchUrl={props.fetchUrl} exportUrl={props.exportUrl} />;
}

const rootEl = document.getElementById('unallocatedSummary');

if (rootEl) {
    ReactDOM.render(
        <App>
            <UnallocatedExpensesIndex fetchUrl={rootEl.getAttribute('data-fetch-url')} exportUrl={rootEl.getAttribute('data-export-url')} />
        </App>,
        rootEl,
    );
}
